export const SET_START_DATE = "SET_START_DATE";
export const SET_START_TIME = "SET_START_TIME";
export const SET_END_DATE = "SET_END_DATE";
export const SET_END_TIME = "SET_END_TIME";